import { useMemo } from "react";
import { ConversationDto } from "../dto/conversation";

type Args = {
  convo: ConversationDto;
  myOperatorId: string | null;
  isSupervisor: boolean;
};

export type ConversationLockState = {
  canOpen: boolean;
  isMine: boolean;
  isLockedForMe: boolean;
  lockDisabled: boolean | undefined;
  lockTooltip?: string;
};

const DEFAULT_LOCK_TOOLTIP =
  "Conversazione assegnata o bloccata da un altro operatore";

export function getConversationLockState({
  convo,
  myOperatorId,
  isSupervisor,
}: Args): ConversationLockState {
  const isMine = !!myOperatorId && convo.operatorId === myOperatorId;

  const lockedExplicitlyByOther =
    !!myOperatorId &&
    !!convo.lockedByOperatorId &&
    convo.lockedByOperatorId !== myOperatorId;

  const isLockedForMe = !isSupervisor && lockedExplicitlyByOther;

  const canOpen = isSupervisor || isMine || !isLockedForMe;

  return {
    canOpen,
    isMine,
    isLockedForMe,
    lockDisabled: isLockedForMe ? true : undefined,
    lockTooltip: isLockedForMe ? DEFAULT_LOCK_TOOLTIP : undefined,
  };
}

export function useConversationLockState(args: Args): ConversationLockState {
  return useMemo(
    () => getConversationLockState(args),
    [
      args.convo.operatorId,
      args.convo.lockedByOperatorId,
      args.myOperatorId,
      args.isSupervisor,
    ]
  );
}
